
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { InvestmentOpportunity } from "@/types/investment";

interface PropertyLinksSectionProps {
  formData: InvestmentOpportunity;
  onInputChange: (field: keyof InvestmentOpportunity, value: any) => void;
}

const PropertyLinksSection = ({ formData, onInputChange }: PropertyLinksSectionProps) => {
  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold mb-4">Property Links</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="realtor_com_link">Realtor.com Link</Label>
          <Input
            id="realtor_com_link"
            type="url"
            value={formData.realtor_com_link || ''}
            onChange={(e) => onInputChange('realtor_com_link', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="zillow_com_link">Zillow.com Link</Label>
          <Input
            id="zillow_com_link"
            type="url"
            value={formData.zillow_com_link || ''}
            onChange={(e) => onInputChange('zillow_com_link', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="county_assessor_link">County Assessor Link</Label>
          <Input
            id="county_assessor_link"
            type="url"
            value={formData.county_assessor_link || ''}
            onChange={(e) => onInputChange('county_assessor_link', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="documents_link">Documents Link</Label>
          <Input
            id="documents_link"
            type="url"
            value={formData.documents_link || ''}
            onChange={(e) => onInputChange('documents_link', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyLinksSection;
